import http from '@/services/http'
import { formatErrors } from '@utils/errors-alert'
import { bus } from '@/plugins/event-bus'

const changeStatusDoc = ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    const response = http.put('/manage_invoice_documents/change_status', data)
    response.then((response) => {
      resolve(response.data)
    }).catch((error) => {
      commit('SET_ERRORS_DOCS', error.response.data)
      reject(error)
    })
  })
}

const changeSituationDoc = ({ commit }, obj = { document_id: '', code: '' }) => {
  return new Promise(async (resolve, reject) => {
    const response = http.put('/manage_invoice_documents/change_situation', obj)
    response.then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

const sendDocs = ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    const response = http.post('/manage_invoice_documents/new', data)
    response.then((response) => {
      commit('RESET_ERRORS_DOCS')
      resolve(response.data)
    }).catch((error) => {
      commit('SET_ERRORS_DOCS', error.response.data)
      reject(error)
    })
  })
}

const resetErrors = ({ commit }) => {
  commit('RESET_ERRORS_DOCS')
}

export default {
  changeStatusDoc,
  changeSituationDoc,
  sendDocs,
  resetErrors
}



// WEBPACK FOOTER //
// ./src/features/payer_invoice_upload/store/actions.js